<template>
  <div class="home" :style="{width: homeWidth}">
    <template v-if="token">
      <!-- 头部 -->
      <div class="fd-r jc-sb" :class="scrollTop !== 0 ? 'QKrU5e' : ''" style="height: 56px;width: 100%;padding: 0 18px 0 16px;position: sticky;top: 0;background: white;z-index: 999; transition: box-shadow .2s ease-in-out;">
        <div class="fd-r">
          <svg style="height: 40px;width: 40px;margin-right: 8px;" aria-hidden="true" viewBox="0 0 40 40">
            <path fill="none" d="M0,0h40v40H0V0z"></path>
            <g>
              <path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z" fill="#EA4335"></path>
              <path d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z" fill="#FBBC04"></path>
              <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4"></path>
              <path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z" fill="#34A853"></path>
            </g>
          </svg>
          <div style="line-height: 1.75rem; font-size:1.375rem;color: #5F6368;">{{$t('title')}}</div>
        </div>
        <div class="fd-r">
          <img style="width: 28px;height: 28px;margin-right: 20px;" src="@/assets/icon-search.png" alt="search">
          <img style="width: 28px;height: 28px;margin-right:20px;" src="@/assets/icon-question.png" alt="question">
          <img style="width: 32px;height: 32px;" src="@/assets/icon-head.png" alt="head">
        </div>
      </div>
      <div style="padding: 0 24px;">
        <!-- 应用图片名称 -->
        <div class="fd-r ai-s" style="margin-top: 48px;">
          <img style="border-radius:20%;box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);margin: 7px 24px 0 0;width: 72px;" :src="info.image" :alt="info.title">
          <div class="fd-c">
            <div style="font-size:1.5rem;line-height: 2rem;color: inherit;">{{info.title}}</div>
            <div style="font-size:1rem;color: #01875f;margin-top: 2px;">{{info.issue}}</div>
          </div>
        </div>
        <!-- 评价/下载 -->
        <div class="fd-r jc-c" style="margin: 16px 0 24px 0;padding: 12px 0;overflow-x: auto;">
          <div class="fd-c ai-c wVqUob" style="padding: 0 24px">
            <div class="fd-r">
              <div style="font-size: 0.875rem; line-height: 1.25rem;">{{info.score}}</div>
              <i class="google-material-icons">★</i>
            </div>
            <div style="font-size: .75rem;color:rgb(95,99,104) ;line-height: 1rem;margin-top: 2px;white-space: nowrap;">{{info.offer}}K {{$t('reviews')}}</div>
          </div>
          <div class="fd-c ai-c wVqUob" style="padding: 0 24px;">
            <div style="font-size: 0.875rem; line-height: 1.25rem;">{{info.store}}M+</div>
            <div style="font-size: .75rem;color:rgb(95,99,104) ;line-height: 1rem;margin-top: 2px;">{{$t('download')}}</div>
          </div>
          <div class="fd-c ai-c wVqUob" style="padding: 0 24px;">
            <div style="line-height: 1.25rem;">
              <img :src="require(`@/assets/icon-${info.stint}.png`)" style="height: 16px;" alt="ago">
            </div>
            <div class="fd-r" style="margin-top: 2px;">
              <div style="font-size: .75rem;color:rgb(95,99,104) ;line-height: 1rem;white-space: nowrap;">Rated for {{info.stint}}+</div>
              <img style="width: 12px;height: 12px;margin-left: 4px;" src="@/assets/icon-exclamation.png" alt="exclamation">
            </div>
          </div>
        </div>
        <!-- 安装按钮 -->
        <div v-if="progress > 0 && progress !== 100" class="progress-bar" style="position: relative;">
          <div class="progress" :style="{ width: progress + '%',color:'white' }"></div>
          <div style="position: absolute;left: 0;top: 0;width: 100%;text-align: center;line-height: 36px;"> {{ progress + '%'}}</div>
        </div>
        <div v-else class="fd-r jc-c install-btn" @click="toInstall" style="border-radius: 4px;height: 36px;background:#01875f ;color: white;font-size: .875rem;margin: 6px;">
          {{progress === 100 || state === 'installed' ? $t('play') : $t('install')}}
        </div>
        <!-- 分享和添加心愿单 -->
        <div class="fd-r jc-c" style="gap: 8px;">
          <div class="fd-r" style="height: 48px;padding: 0 8px;">
            <div class="fd-r" style="margin-right: 8px;">
              <svg class="bQL56b" width="24" height="24" viewBox="0 0 24 24" fill="#01875f">
                <path
                  d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z">
                </path>
              </svg>
            </div>
            <div style="font-size: 0.875rem;color: #01875f;">{{$t('share')}}</div>
          </div>
          <div class="fd-r" style="height: 48px;padding: 0 8px;">
            <div class="fd-r" style="margin-right: 8px;">
              <svg class="XkAcee" width="24" height="24" viewBox="0 0 24 24" fill="#01875f">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z">
                </path>
              </svg>
            </div>
            <div style="font-size: 0.875rem;color: #01875f;">{{$t('wishlist')}}</div>
          </div>
        </div>
        <!-- 应用内案例图片 -->
        <div class="fd-r" style="margin-top: 6px;overflow-x: auto;flex-wrap: nowrap;gap: 12px;padding: 3px;">
          <img v-for="(item,index) in info.album" :key="index" preview="0" style="height: 204px;border-width: 0;box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);border-radius: 8px;cursor: pointer;" :src="item" :alt="index">
        </div>

        <!-- 关于此应用 -->
        <div class="fd-r jc-sb" style="padding: 17px 0 20px 0;">
          <div style="line-height: 1.5rem;font-size: 1.125rem;">{{$t('about')}}</div>
          <img src="@/assets/icon-right.png" style="width: 20px;height: 20px;" alt="right">
        </div>
        <div style="color: rgb(95, 99, 104);font-size: .875rem;line-height: 1.25rem;" v-html="info.brief"></div>
        <div class="fd-c" style="margin-top: 24px;">
          <div style="font-size: .875rem;line-height: 1.25rem;">{{$t('updated')}}</div>
          <div style="color: rgb(95,99,104);
      font-size: .875rem;
      line-height: 1.25rem;
      font-weight: 400;
      letter-spacing: .0142857143em;
      margin-top: 4px;">{{info.renew}}</div>
        </div>
        <div v-if="info.label.length>0" class="fd-r" style="gap: 16px 12px;margin-bottom: 4px;
    margin-top: 28px;flex-wrap: wrap;">
          <div v-for="item in info.label" :key="item" class="fd-r" style="min-height: auto;font-size: .875rem;
      padding: 0 15px 0 15px;
      height: 32px;border-radius: 16px;color: rgb(95, 99, 104);border: 1px solid rgb(218, 220, 224);">{{item}}</div>
        </div>
        <!-- 数据安全 -->
        <div class="fd-r jc-sb" style="padding:20px 0;">
          <div style="line-height: 1.5rem;font-size: 1.125rem;">{{$t('data_safety')}}</div>
          <img src="@/assets/icon-right.png" style="width: 20px;height: 20px;" alt="right">
        </div>
        <div style="color: rgb(95, 99, 104);font-size: .875rem">{{$t('data_1')}}</div>
        <div style="
    border-radius: 8px;
    border: 1px solid rgb(218, 220, 224);
    margin-top: 30px;
    padding: 20px 20px 0;">
          <div class="fd-r ai-fs">
            <img style="height: 20px;
      margin-right: 20px;
      width: 20px;" src="@/assets/icon-share.png" alt="share">
            <div class="fd-c">
              <div style="font-size:.875rem;color:rgb(95, 99, 104);">{{$t('data_2')}}</div>
              <div style="font-size:.75rem;color:rgb(95, 99, 104);">{{$t('data_3')}}</div>
            </div>
          </div>
          <div class="fd-r ai-fs" style="margin-top: 20px;">
            <img style="height: 20px;
      margin-right: 20px;
      width: 20px;" src="@/assets/icon-upload.png" alt="upload">
            <div class="fd-c">
              <div style="font-size:.875rem;color:rgb(95, 99, 104);">{{$t('data_4')}}</div>
              <div style="font-size:.75rem;color:rgb(95, 99, 104);">{{$t('data_5')}}</div>
            </div>
          </div>
          <div class="fd-r ai-fs" style="margin-top: 20px;">
            <img style="height: 20px;
      margin-right: 20px;
      width: 20px;" src="@/assets/icon-lock.png" alt="lock">
            <div style="font-size:.875rem;color:rgb(95, 99, 104);">{{$t('data_6')}}</div>
          </div>
          <div class="fd-r ai-fs" style="margin-top: 20px;">
            <img style="height: 20px;
      margin-right: 20px;
      width: 20px;" src="@/assets/icon-del.png" alt="delete">
            <div style="font-size:.875rem;color:rgb(95, 99, 104);">{{$t('data_7')}}</div>
          </div>
          <div class="fd-r" style="color: #01875f;font-size: .875rem;height: 36px;margin: 10px 0;">{{$t('data_8')}}
          </div>
        </div>
        <!-- 评分 -->
        <div class="fd-r jc-sb" style="padding-top:20px;">
          <div style="line-height: 1.5rem;font-size: 1.125rem;">{{$t('reviews_1')}}</div>
          <img src="@/assets/icon-right.png" style="width: 20px;height: 20px;" alt="right">
        </div>
        <div class="fd-r" style="height: 36px;margin: 6px 0;">
          <div style="font-size: .75rem;color: #5F6368;">{{$t('reviews_2')}}</div>
          <img style="width: 13px;height: 13px;margin-left: 8px;" src="@/assets/icon-exclamation.png" alt="exclamation">
        </div>
        <div class="fd-r" style="gap: 16px 12px;margin-bottom: 12px;
    margin-top: 28px;">
          <div class="fd-r" style="min-height: auto;
      padding: 0 15px 0 15px;
      height: 32px;border-radius: 16px;border: 1px solid #e6f3ef;background: #e6f3ef;">
            <img src="@/assets/icon-phone.png" style="width: 18px;height: 18px;margin-right: 8px;" alt="phone">
            <div style="font-size: .875rem;color: #056449;">{{$t('phone')}}</div>
          </div>
          <div class="fd-r" style="min-height: auto;font-size: .875rem;
      padding: 0 15px 0 15px;
      height: 32px;border-radius: 16px;color: #5F6368;border: 1px solid rgb(218, 220, 224);">
            <img src="@/assets/icon-tablet.png" style="width: 17px;height: 17px;margin-right: 8px;" alt="tablet">
            <div style="font-size: .875rem;color: #5F6368;">{{$t('tablet')}}</div>
          </div>
          <!-- <div class="fd-r" style="min-height: auto;font-size: .875rem;padding: 0 15px 0 15px;height: 32px;border-radius: 16px;color:#5F6368;border: 1px solid rgb(218, 220, 224);">Choromebook</div> -->
        </div>
        <div class="fd-r ai-fs" style="gap: 24px;padding-top: 24px;padding-bottom: 16px;">
          <div class="fd-c">
            <div style="font-size: 3.5rem;color: #202124;">{{info.score}}</div>
            <div class="star-container">
              <div v-for="(star, index) in 5" :key="index" class="star">
                <span class="star-filled" :style="{ width: getStarFillWidth(index,info.score) + '%' }">★</span>
                <span style="color:rgb(241,243,244);">★</span>
              </div>
            </div>
            <div style="margin-top: .6rem;font-size: .75rem;color: #5F6368;">{{info.offer}}K {{$t('reviews')}}</div>
          </div>
          <div class="fd-c" style="flex: 1;">
            <div class="fd-r">
              <div style="margin-right: 16px;font-size: .75rem;color: #5F6368;line-height: 1rem;">5</div>
              <div style="flex: 1;background: rgb(232,234,237);height: 10px;border-radius: 9999px;">
                <div style="width: 30%;background: #01875f;height: 10px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div style="margin-right: 16px;font-size: .75rem;color: #5F6368;line-height: 1rem;">4</div>
              <div style="flex: 1;background: rgb(232,234,237);height: 10px;border-radius: 9999px;">
                <div style="width: 30%;background: #01875f;height: 10px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div style="margin-right: 16px;font-size: .75rem;color: #5F6368;line-height: 1rem;">3</div>
              <div style="flex: 1;background: rgb(232,234,237);height: 10px;border-radius: 9999px;">
                <div style="width: 30%;background: #01875f;height: 10px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div style="margin-right: 16px;font-size: .75rem;color: #5F6368;line-height: 1rem;">2</div>
              <div style="flex: 1;background: rgb(232,234,237);height: 10px;border-radius: 9999px;">
                <div style="width: 30%;background: #01875f;height: 10px;border-radius: 9999px;"></div>
              </div>
            </div>
            <div class="fd-r">
              <div style="margin-right: 16px;font-size: .75rem;color: #5F6368;line-height: 1rem;">1</div>
              <div style="flex: 1;background: rgb(232,234,237);height: 10px;border-radius: 9999px;">
                <div style="width: 30%;background: #01875f;height: 10px;border-radius: 9999px;"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- 评价 -->
        <div v-for="(item,index) in info.forum" :key="index" style="padding: 16px 0;">
          <div class="fd-r jc-sb">
            <div class="fd-r" style="gap: 16px;">
              <img style="width: 32px;height: 32px;border-radius: 50%;background-size: cover;overflow: hidden;" :src="item.photo" :alt="item.title">
              <div style="font-size: .875rem;">{{item.title}}</div>
            </div>
            <img style="width: 20px;height: 20px;" src="@/assets/icon-drop.png" alt="drop">
          </div>
          <div class="fd-r" style="margin-top: 16px;">
            <div class="star-container2">
              <div v-for="(star, index) in 5" :key="index" class="star">
                <span class="star-filled" :style="{ width: getStarFillWidth(index, item.score) + '%' }">★</span>
                <span style="color:rgb(241,243,244);">★</span>
              </div>
            </div>
            <div style="color: #5F6368;font-size: .75rem;margin-left: 1ch;">{{item.issue}}</div>
          </div>
          <div style="font-size: .875rem;margin-top: 8px;color: #5F6368;">{{item.intel}}</div>
          <div style="font-size: .75rem;margin-top: 16px;color: #5F6368;">{{item.agree}} {{$t('helpful_1')}}</div>
          <div class="fd-r" style="margin-top: 12px;">
            <div style="font-size: .75rem;color: #5F6368;margin-right: 24px;">{{$t('helpful_2')}}</div>
            <div class="fd-r" style="gap: 12px;">
              <div class="fd-r" style="font-size: 14px;
       padding: 0 16px;
       height: 24px;border-radius: 9999px;color:#5F6368;border: 1px solid rgb(218, 220, 224);">{{$t('button_yes')}}</div>
              <div class="fd-r" style="font-size: 14px;
       padding: 0 16px;
       height: 24px;border-radius: 9999px;color:#5F6368;border: 1px solid rgb(218, 220, 224);">{{$t('button_no')}}</div>
            </div>
          </div>
        </div>
        <div class="fd-r" style="color: #01875f;font-size: .875rem;height: 36px;margin: 6px 0;padding: 0 8px;">{{$t('button_reviews')}}</div>
        <!-- 应用支持 -->
        <div class="fd-r jc-sb" style="display:none; padding-top:20px;">
          <div style="line-height: 1.5rem;font-size: 1.125rem;">App support</div>
          <img :src="show ? require('@/assets/icon-up.png') : require('@/assets/icon-down.png')" style="width: 16px;height: 16px;" @click="show=!show" alt="support">
        </div>
        <template v-if="show">
          <div class="fd-r" style="margin-top: 20px;">
            <img style="margin-right: 16px;width: 20px;height: 20px;" src="@/assets/icon-earth.png" alt="earth">
            <div style="font-size:.875rem">Website</div>
          </div>
          <div class="fd-r ai-fs" style="margin-top: 20px;">
            <img style="margin-right: 16px;width: 20px;height: 20px;" src="@/assets/icon-email.png" alt="email">
            <div class="fd-c">
              <div style="font-size:.875rem;">Support email</div>
              <div style="font-size:.875rem;color: #5F6368;">google-play-emails@twitter.com</div>
            </div>
          </div>
          <div class="fd-r" style="margin-top: 20px;">
            <img style="margin-right: 16px;width: 20px;height: 20px;" src="@/assets/icon-shield.png" alt="shield">
            <div style="font-size:.875rem">Privacy Policy</div>
          </div>
          <div style="font-size: .875rem;margin-top: 20px;padding-bottom: 12px;">About the developer</div>
          <div style="font-size: .875rem;color: #5F6368;line-height: 1.25rem;">X Corp.</div>
          <div style="font-size: .875rem;color: #5F6368;line-height: 1.25rem;">android-support@x.com</div>
          <div style="font-size: .875rem;color: #5F6368;white-space: pre-line;line-height: 1.25rem;">
            865 FM 1209 Bldg 2
            Bastrop, TX 78602-3227
            United States</div>
          <div style="font-size: .875rem;color: #5F6368;line-height: 1.25rem;">+1 415-295-2756</div>
        </template>
        <!-- 类似应用 -->
        <div class="fd-r jc-sb" style="display:none; padding-top:20px;">
          <div style="line-height: 1.5rem;font-size: 1.125rem;">Similar apps</div>
          <img src="@/assets/icon-right.png" style="width: 20px;height: 20px;" alt="right">
        </div>
        <div style="display: grid;display:none; grid-gap: 24px;grid-template-columns: repeat(2, 1fr);margin-top: 20px">
          <div class="fd-r" style="overflow: hidden;">
            <img style="border-radius: 12px;box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);height: 56px;width: 56px;" src="">
            <div class="fd-c jc-sb" style="margin-left: 12px;flex:1">
              <div style="overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;">Telegram X</div>
              <div style="overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;">Telegram FZ-LLC</div>
              <div class="fd-r">
                <div style="color: #5F6368;font-size: .75rem;">4.1</div>
                <span style="color:#5F6368;font-size: .625rem;">★</span>
              </div>
            </div>
          </div>
          <div class="fd-r" style="overflow: hidden;">
            <img style="border-radius: 12px;box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);
        height: 56px;
        width: 56px;" src="">
            <div class="fd-c jc-sb" style="margin-left: 12px;flex:1">
              <div style="overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;">Telegram X</div>
              <div style="overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;">Telegram FZ-LLC</div>
              <div class="fd-r">
                <div style="color: #5F6368;font-size: .75rem;">4.1</div>
                <span style="color:#5F6368;font-size: .625rem;">★</span>
              </div>
            </div>
          </div>
          <div class="fd-r" style="overflow: hidden;">
            <img style="border-radius: 12px;box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 1px 3px 1px rgba(60, 64, 67, .15);height: 56px;width: 56px;" src="">
            <div class="fd-c jc-sb" style="margin-left: 12px;flex:1">
              <div style="overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;">Telegram X</div>
              <div style="overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;">Telegram FZ-LLC</div>
              <div class="fd-r">
                <div style="color: #5F6368;font-size: .75rem;">4.1</div>
                <span style="color:#5F6368;font-size: .625rem;">★</span>
              </div>
            </div>
          </div>
        </div>
        <div class="fd-r" style="display:none; margin-top: 20px;">
          <img style="width: 18px;height: 18px;margin-right: 16px;" src="@/assets/icon-flag.png" alt="flag">
          <div style="font-size:.875rem;">举报不当内容</div>
        </div>
        <div style="width: 100%;border-bottom: 1px solid rgb(232,234,237);
    margin-bottom: 36px;
    padding-top: 36px;"></div>
        <!-- 底部快捷链接 -->
        <div class="fd-c">
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">Google Play</div>
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">Play Pass</div>
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">Play Points</div>
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">{{$t('gift_cards')}}</div>
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">{{$t('redeem')}}</div>
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">{{$t('refund_policy')}}</div>
        </div>
        <div class="fd-c" style="margin-top: 24px;">
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">{{$t('kids_family')}}</div>
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">{{$t('parent_guide')}}</div>
          <div style="font-size: .875rem;line-height: 32px;color: #5F6368;">{{$t('family_sharing')}}</div>
        </div>
        <div class="fd-r" style="flex-wrap: wrap;margin-top: 32px;padding-bottom: 16px;">
          <div style="font-size:.75rem;color: #5F6368;line-height: 48px;margin-right: 24px;">{{$t('terms_of_service')}}
          </div>
          <div style="font-size:.75rem;color: #5F6368;line-height: 48px;margin-right: 24px;">{{$t('privacy')}}</div>
          <div style="font-size:.75rem;color: #5F6368;line-height: 48px;margin-right: 24px;">{{$t('about_google')}}
          </div>
          <div style="font-size:.75rem;color: #5F6368;line-height: 48px;margin-right: 24px;">{{$t('developers')}}</div>
          <div style="font-size:.75rem;color: #5F6368;line-height: 48px;margin-right: 24px;">Google Store</div>
          <!-- <div style="font-size:.75rem;color: #5F6368;line-height: 48px;">中国 (简体中文)</div> -->
        </div>
      </div>
      <!-- 底部菜单 -->
      <div class="fd-r jc-sa" style="position: sticky;bottom: 0;border-top: 1px solid rgb(218, 220, 224);
        height: 56px;background: white;">
        <div class="fd-c ai-c">
          <svg width="24" height="24" viewBox="0 0 21 16" fill="#5F6368" class="Y4jiDf">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3 8.4C19.2169 7.65213 19.0648 6.90427 18.9009 6.09902C18.8676 5.93522 18.8338 5.76904 18.8 5.6L18.8 5.59986C18.7 5.1 18.7 5.09996 18.6 4.7L18.5 4.4C18.2 1.8 16 0 13.3 0H6.7C4.1 0 1.8 1.8 1.4 4.4C1.4 4.43174 1.4 4.4534 1.3968 4.47458C1.38993 4.52014 1.36826 4.56347 1.3 4.7C1.3 5.1 1.3 5.1 1.2 5.6C1.1 6.05 1.025 6.525 0.95 7C0.875 7.475 0.8 7.95 0.7 8.4C0.1 11.9 0 12.5 0 12.7C0 14.2 1.2 15.5 2.8 15.5C3.6 15.5 4.3 15.2 4.8 14.7L7.7 11.9H12.4L15.3 14.8C15.8 15.3 16.5 15.6 17.3 15.6C18.8 15.6 20.1 14.4 20.1 12.8C20.0055 12.5165 19.911 11.9651 19.3946 8.95177L19.3 8.4ZM13 5C13.4971 5 13.9 4.59706 13.9 4.1C13.9 3.60294 13.4971 3.2 13 3.2C12.5029 3.2 12.1 3.60294 12.1 4.1C12.1 4.59706 12.5029 5 13 5ZM15.8 6C15.8 6.49706 15.3971 6.9 14.9 6.9C14.4029 6.9 14 6.49706 14 6C14 5.50294 14.4029 5.1 14.9 5.1C15.3971 5.1 15.8 5.50294 15.8 6ZM10.5 5.4C10.2 5.7 10.2 6.3 10.5 6.6C10.8 6.9 11.4 6.9 11.7 6.6C12 6.3 12 5.7 11.7 5.4C11.4 5.1 10.9 5.1 10.5 5.4ZM13 8.8C13.4971 8.8 13.9 8.39706 13.9 7.9C13.9 7.40294 13.4971 7 13 7C12.5029 7 12.1 7.40294 12.1 7.9C12.1 8.39706 12.5029 8.8 13 8.8ZM6.4 3.5H7.6V5.4H9.5V6.6H7.6V8.5H6.4V6.6H4.5V5.4H6.4V3.5ZM16.5 13.3C16.7 13.5 16.9 13.6 17.2 13.6C17.8 13.6 18.2 13.2 18.2 12.6C18.2 12.7 16.8 4.8 16.8 4.7C16.5 3 15 1.8 13.3 1.8H6.7C4.9 1.8 3.5 3 3.2 4.7C3.2 4.8 1.8 12.7 1.8 12.7C1.8 13.3 2.3 13.7 2.8 13.7C3.1 13.7 3.3 13.6 3.5 13.4L6.9 10H13.1L13.4 10.2L16.5 13.3Z"></path>
          </svg>
          <div style="font-size: .875rem;line-height: 1.25rem;color: #5F6368;">{{$t('games')}}</div>
        </div>
        <div class="fd-c ai-c">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#01875f" xmlns="http://www.w3.org/2000/svg" class="VuUAje ndrlL">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 4H18C19.1 4 20 4.9 20 6V9C20 10.1 19.1 11 18 11H15C13.9 11 13 10.1 13 9V6C13 4.9 13.9 4 15 4ZM9 13H6C4.9 13 4 13.9 4 15V18C4 19.1 4.9 20 6 20H9C10.1 20 11 19.1 11 18V15C11 13.9 10.1 13 9 13ZM18 13H15C13.9 13 13 13.9 13 15V18C13 19.1 13.9 20 15 20H18C19.1 20 20 19.1 20 18V15C20 13.9 19.1 13 18 13ZM9 4H6C4.9 4 4 4.9 4 6V9C4 10.1 4.9 11 6 11H9C10.1 11 11 10.1 11 9V6C11 4.9 10.1 4 9 4Z"></path>
          </svg>
          <div style="font-size: .875rem;line-height: 1.25rem;color: #01875f;">{{$t('apps')}}</div>
        </div>
        <div class="fd-c ai-c">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#5F6368" xmlns="http://www.w3.org/2000/svg" class="Y4jiDf">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4996 6.36584L14.001 7.65237V4H11.001V7.65075L12.4996 6.36584ZM10 2H11.001H14.001H15H16.998C18.6461 2 20.001 3.35397 20.001 5.002V18.998C20.001 20.646 18.6461 22 16.998 22H4V2H10ZM18.001 5.002C18.001 4.459 17.542 4 16.998 4H16.001V12L12.5 9L9.001 12V4H6V20H16.998C17.542 20 18.001 19.541 18.001 18.998V5.002Z">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15 4H18C19.1 4 20 4.9 20 6V9C20 10.1 19.1 11 18 11H15C13.9 11 13 10.1 13 9V6C13 4.9 13.9 4 15 4ZM9 13H6C4.9 13 4 13.9 4 15V18C4 19.1 4.9 20 6 20H9C10.1 20 11 19.1 11 18V15C11 13.9 10.1 13 9 13ZM18 13H15C13.9 13 13 13.9 13 15V18C13 19.1 13.9 20 15 20H18C19.1 20 20 19.1 20 18V15C20 13.9 19.1 13 18 13ZM9 4H6C4.9 4 4 4.9 4 6V9C4 10.1 4.9 11 6 11H9C10.1 11 11 10.1 11 9V6C11 4.9 10.1 4 9 4Z"></path>
            </path>
          </svg>
          <div style="font-size: .875rem;line-height: 1.25rem;color: #5F6368;">{{$t('books')}}</div>
        </div>
        <div class="fd-c ai-c">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#5F6368" xmlns="http://www.w3.org/2000/svg" class="Y4jiDf">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 20.439C13.1543 20.787 17.2264 22 17.6293 22C18.4311 22 18.928 21.578 19.154 21.325C19.7049 20.7081 19.7029 20.0604 19.6999 19.0794L19.6999 19.074C19.6989 18.647 19.6299 16.111 19.6009 15.125C20.2258 14.252 21.8914 11.907 22.1604 11.5C22.7292 10.643 23.2201 9.901 22.8972 8.908C22.5724 7.90856 21.7594 7.61034 20.8112 7.26259L20.8096 7.262C20.3747 7.103 17.7853 6.254 16.8195 5.942C16.2026 5.107 14.518 2.848 14.221 2.476L14.2198 2.47445C13.5875 1.68311 13.0416 1 11.9995 1C10.9577 1 10.4108 1.684 9.77797 2.477C9.48103 2.848 7.79639 5.107 7.18052 5.942C6.21372 6.255 3.62427 7.103 3.18436 7.265C2.24156 7.61 1.42773 7.908 1.1028 8.908C0.779871 9.901 1.27077 10.643 1.83965 11.501C2.10059 11.894 3.77424 14.252 4.39911 15.125C4.37011 16.111 4.30113 18.646 4.29913 19.074V19.0741C4.29613 20.058 4.29415 20.708 4.84501 21.324C5.06996 21.576 5.56686 22 6.37069 22C6.7726 22 10.8447 20.787 11.9995 20.439ZM17.6018 15.1838C17.6437 16.6103 17.6991 18.7493 17.6999 19.0787C17.7021 19.8051 17.6963 19.9322 17.6736 19.9767C17.5616 19.9504 17.418 19.9144 17.2472 19.8699C16.8391 19.7634 16.2949 19.6126 15.6462 19.4271C14.6587 19.1447 13.4965 18.8013 12.5766 18.5241L11.9995 18.3502L11.4224 18.5241C10.5029 18.8012 9.34041 19.1447 8.35292 19.4271C7.7042 19.6126 7.16005 19.7634 6.75206 19.8699C6.58148 19.9145 6.43802 19.9504 6.32604 19.9766C6.30304 19.9326 6.2969 19.8071 6.29912 19.0801C6.30067 18.7488 6.35718 16.5803 6.39824 15.1838L6.41807 14.5095L6.02543 13.9609C5.19866 12.8058 3.70925 10.7011 3.50581 10.3947C3.01485 9.65422 2.98744 9.57977 3.00475 9.52653C3.02422 9.46662 3.06796 9.4373 3.87165 9.1432C4.20463 9.02058 6.39401 8.29883 7.79654 7.84477L8.40835 7.64669L8.79007 7.12916C9.57143 6.06978 11.1071 4.01707 11.3394 3.72674C11.8852 3.04281 11.9401 3 11.9995 3C12.049 3 12.0824 3.02198 12.403 3.40831C12.4693 3.48831 12.5251 3.55748 12.6586 3.72451C12.8889 4.01303 14.4014 6.03473 15.2108 7.1304L15.5929 7.64752L16.2047 7.84516C17.4867 8.25931 19.7877 9.01784 20.1229 9.1404L20.1237 9.1407C20.2142 9.17389 20.2145 9.17398 20.3015 9.20614C20.9377 9.44213 20.977 9.47051 20.9951 9.52605C21.0125 9.57968 20.9851 9.65415 20.4941 10.3939C20.2859 10.7088 18.8457 12.7438 17.9746 13.9609L17.5819 14.5095L17.6018 15.1838Z"></path>
          </svg>
          <div style="font-size: .875rem;line-height: 1.25rem;color: #5F6368;">{{$t('kids')}}</div>
        </div>
      </div>
      <!-- 提示弹窗 -->
      <div v-if="toastShow" style="position: fixed;left: 0;right: 0;top: 0;bottom: 0;margin: auto;width: fit-content;height: fit-content;padding: 6px 12px;background: rgba(0, 0, 0, .7);color:white;border-radius: 4px;">{{toastValue}}</div>
    </template>
    <template v-else>
      <div class="fd-r jc-c" style="margin-bottom: 40px;">
        <img style="width: 80%;height: auto;margin-top: 48px;" src="@/assets/404.png" alt="404">
      </div>
      <div class="fd-r jc-c" style="font-size: 24px;font-weight: bold;line-height: 40px;color: #1482f0;margin-bottom: 20px;">404 Error!</div>
      <div class="fd-r jc-c" style="font-size: 16px;line-height: 24px;color: #222;font-weight: bold;margin-bottom: 10px;">Page not found!</div>
      <div class="fd-r jc-c" style="font-size: 12px;line-height: 22px;color: grey;text-align: center;padding: 0 40px;margin-bottom: 30px;">
        Sorry, the page you are looking for does not exist. Try checking the URL for errors and pressing the refresh
        button on your browser or try to find something else in our app.
      </div>
    </template>
  </div>
</template>

<script>
  import { apiConfig, apiDetail } from "@/api/index.js"
  export default {
    name: 'androidView',
    data() {
      return {
        progress: 0, // 下载进度
        homeWidth: 0, // 屏幕宽度
        scrollTop: 0, // 滚动高度
        show: false, // 应用支持是否展开
        toastShow: false, //提示弹窗开关
        toastValue: "", // 提示弹窗文字
        token: "",
        state: "",
        config: {},
        info: {
          title: "ㅤ",
          issue: "ㅤ",
          image: require("@/assets/logo.png"),
          brief: "ㅤ",
          album: [],
          lingo: "en",
          score: "5.0",
          offer: "1",
          store: "1",
          stint: "3",
          renew: "",
          label: [],
          forum: [
            {
              photo: require("@/assets/logo.png"),
              title: 'Username',
              intel: "Comment Details",
              score: 5,
              issue: '2025-01-01',
              agree: 10
            },
            {
              photo: require("@/assets/logo.png"),
              title: 'Username',
              intel: "Comment Details",
              score: 5,
              issue: '2025-01-01',
              agree: 10
            }
          ]
        }
      }
    },
    mounted() {
      document.title = 'Google Play';

      this.updateIcon();

      this.homeWidth = window.innerWidth + 'px'

      window.addEventListener('scroll', this.handleScroll);

      this.token = this.$route.query.config;  // 获取应用参数

      this.state = localStorage.getItem('install_token');

      if (this.isAndroid()) {
        let research = window.matchMedia('(display-mode: standalone)').matches;

        if (research) {
          window.location.href = window.location.protocol + '//' + window.location.hostname + '/play/' + this.token;
        } else {
          let result = this.detectInAppBrowser();

          if (result === 'telegram' || result === 'facebook') {
            this.RedirectToExternalBrowser();
          }
        }
      } else if (this.isIos()) {
        this.$router.push({ path: '/ios', query: { config: this.token } });return;
      }

      window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);

      if (this.token) {
        const url = `/json/${this.token}/manifest.json?version=` + Date.now()

        const link = document.querySelector('link[rel="manifest"]');
        if (link) {
          link.href = url;
        } else {
          const newLink = document.createElement('link');
          newLink.rel = 'manifest';
          newLink.href = url;
          document.head.appendChild(newLink);
        }

        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.register('/service_worker.js?config=' + this.token + '&version=' + Date.now()).then((registration) => {
            console.log('Service Worker Registration successful:', registration.scope);
          }).catch((error) => {
            console.error('Service Worker Registration failed: ', error);
          });
        } else {
          console.log('The current browser does not support Service Worker');
        }
      }

      // this.apiConfig() // 获取全局配置

      this.apiDetail() // 获取应用详情
    },
    methods: {
      updateIcon() {
        let favicon = document.querySelector('link[rel="icon"]');

        if (!favicon) {
          favicon = document.createElement('link');
          favicon.rel = 'icon';
          document.head.appendChild(favicon);
        }

        favicon.href = 'data:image/vnd.microsoft.icon;base64,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';
      },
      RedirectToExternalBrowser() {
        // window.location.hostname // 获取域名
        // window.location.protocol.replace(':', '') // 获取协议[http/https]

        let param = new URLSearchParams(window.location.search);
        let path = window.location.pathname + '/#/?config=' + param.get('config');
        let fallbackUrl = 'https://play.google.com/store/apps/details?id=com.android.chrome';

        // 构造Intent链接
        // 尝试跳转到Chrome应用
        window.location.href = 'intent://' + window.location.hostname + path + '#Intent;' +
          'scheme=' + window.location.protocol.replace(':', '') + ';' +
          'action=android.intent.action.VIEW;' +
          'category=android.intent.category.BROWSABLE;' +
          'package=com.android.chrome;' +
          'S.browser_fallback_url=' + encodeURIComponent(fallbackUrl) + ';' +
          'end';
      },
      handleBeforeInstallPrompt(e) {
        e.preventDefault()
        this.deferredPrompt = e
      },
      async showInstallPrompt() {
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt();
          this.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
              console.log('用户同意安装');
              this.startProgress()
            } else {
              console.log('用户拒绝安装');
            }
            this.deferredPrompt = null;
          });
        } else {
          this.toast('Installation is not supported');
        }
      },
      // 去安装
      toInstall() {
        let result = this.detectInAppBrowser();

        if (result === 'telegram' || result === 'facebook') {
          this.RedirectToExternalBrowser();
        }

        if (this.progress === 100 || this.state === 'installed') {
          try {
            // window.location.hostname // 获取域名
            // window.location.protocol.replace(':', '') // 获取协议[http/https]
            window.location.href = 'intent://' + window.location.hostname + '/play/' + this.token + '#Intent;' + 'scheme=' + window.location.protocol.replace(':', '') + ';' + 'end';
          } catch (error) {
            window.location.href = "/play/" + this.token
          }
        } else {
          this.showInstallPrompt()
        }
      },
      // 提示
      toast(title) {
        this.toastValue = title;
        this.toastShow = true;
        setTimeout(() => {
          this.toastShow = false
        }, 1500);
      },
      // 判断苹果设备
      isIos() {
        return /iPhone|iPad|iPod/.test(navigator.userAgent);
      },
      // 判断安卓设备
      isAndroid() {
        return /Android/.test(navigator.userAgent);
      },
      // 是否Safari浏览器
      isSafari() {
        return /iPhone|iPad|iPod/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent) && !/CriOS|Chrome/.test(navigator.userAgent);
      },
      apiConfig() {
        apiConfig().then(res => {
          this.config = res.data
        })
      },
      apiDetail() {
        apiDetail({
          token: this.token
        }).then(res => {
          if (res.data.title !== undefined && res.data.title !== '') {
            this.info = {
              title: res.data.title ?? this.info.title,
              issue: res.data.issue ?? this.info.issue,
              image: res.data.image ?? this.info.image,
              brief: res.data.brief ? res.data.brief.replace(/\n/g, "<br/>") : this.info.brief,
              album: res.data.album ?? this.info.album,
              lingo: res.data.lingo ?? this.info.lingo,
              score: res.data.score ?? this.info.score,
              offer: res.data.offer ?? this.info.offer,
              store: res.data.store ?? this.info.store,
              stint: res.data.stint ?? this.info.stint,
              renew: res.data.renew ?? this.info.renew,
              label: res.data.label ?? this.info.label,
              forum: res.data.forum ?? this.info.forum
            }

            this.$i18n.locale = this.info.lingo
          } else {
            this.token = ""
          }
        })
      },
      // 评分星星颜色处理
      getStarFillWidth(index, totalScore) {
        const starIndex = index + 1;
        if (totalScore >= starIndex) {
          return 100;
        } else if (totalScore > starIndex - 1) {
          return (totalScore - (starIndex - 1)) * 100;
        }
        return 0;
      },
      handleScroll() {
        // 获取滚动条位置
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      },
      // 进度条
      startProgress() {
        let interval = setInterval(() => {
          if (this.progress < 100) {
            this.progress += 1; // 每次增加 5
          } else {
            clearInterval(interval); // 达到100后停止
          }
        }, 100); // 每秒更新一次
      },
      detectInAppBrowser() {
        const ua = navigator.userAgent.toLowerCase();
        const isIOS = /iphone|ipad|ipod/i.test(ua);
        const isAndroid = /android/i.test(ua);

        // 检测设备品牌（华为、小米、三星等）
        const deviceBrand = (() => {
          if (/huawei|honor/i.test(ua)) return 'huawei';
          if (/xiaomi|redmi|mi\s/i.test(ua)) return 'xiaomi';
          if (/samsung/i.test(ua)) return 'samsung';
          if (/oppo/i.test(ua)) return 'oppo';
          if (/vivo/i.test(ua)) return 'vivo';
          return 'other';
        })();

        // --------------------------
        // 1. 检测 Facebook 特征
        // --------------------------
        // 方法1: User Agent 特征（iOS/Android 通用）
        const isFacebookUA = (
          //(isIOS && ua.includes('fban/fbios')) || (isAndroid && ua.includes('fban') && ua.includes('fbav'))
          (isIOS && ua.includes('fban/fbios')) || (isAndroid && ua.includes('fb_iab/fb4a'))
        );

        // 方法2: URL 参数（Facebook 自动添加 fbclid）
        // const hasFbclid = new URLSearchParams(location.search).has('fbclid');

        // 方法3: 检测 Facebook 注入的 JavaScript 对象
        const hasFbBridge = typeof window.FBMobileBridge !== 'undefined';

        /*if (isFacebookUA || hasFbclid || hasFbBridge) {
            return 'facebook';
        }*/
        if (isFacebookUA || hasFbBridge) {
          return 'facebook';
        }

        // --------------------------
        // 2. 检测 Telegram 特征
        // --------------------------
        // 方法1: URL 参数（Telegram 分享自动添加）
        // const params = new URLSearchParams(location.search);
        // const isTgParams = params.has('tg_share_source') || params.get('utm_source') === 'telegram';

        // 方法2: 检测 Telegram WebApp 对象
        const hasTgWebApp = window.Telegram?.WebApp?.initDataUnsafe?.user !== undefined;

        // 方法3: WebView 特征（不同设备适配）
        const isTgWebView = (
          (isAndroid && /; wv\).*chrome\//i.test(ua)) ||
          (isIOS && !ua.includes('safari/') && ua.includes('applewebkit/'))
        );

        // 方法4: 针对不同设备的 WebView 标识（如华为、小米的 WebView UA）
        const deviceWebViewMarkers = {
          huawei: /hwwebview/i,
          xiaomi: /miuibrowser/i,
          samsung: /samsungbrowser/i,
          oppo: /heytapbrowser/i,
          vivo: /vivobrowser/i
        };
        if (deviceWebViewMarkers[deviceBrand]?.test(ua)) {
          return 'telegram'; // 假设 Telegram 使用系统 WebView
        }

        /* if (isTgParams || hasTgWebApp || isTgWebView) {
          return 'telegram';
        } */
        if (hasTgWebApp || isTgWebView) {
          return 'telegram';
        }

        // --------------------------
        // 3. 补充检测（跨设备兜底）
        // --------------------------
        // 检测通用 WebView 特征（如无品牌标识的 Android WebView）
        const isGenericWebView = (
          (isAndroid && ua.includes('wv)')) ||
          (isIOS && ua.includes('applewebkit') && !ua.includes('safari/'))
        );

        // 检测浏览器是否屏蔽弹窗（应用内浏览器通常限制）
        if (isGenericWebView) return 'other'; // 可能是其他应用内浏览器

        return 'other';
      },
    }
  }
</script>
<style scoped>
  .home {
    margin: auto;
    max-width: 500px;
    position: relative;
  }

  .google-material-icons {
    font-family: 'Google Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }

  .wVqUob {
    position: relative;
  }

  .wVqUob:not(:first-child)::before {
    background-color: rgb(232, 234, 237);
    content: "";
    display: block;
    height: 24px;
    left: 0;
    position: absolute;
    top: calc(50% - 12px);
    width: 1px;
  }

  .star-container {
    display: flex;
    font-size: 14px;
    color: #ccc;
    gap: 2px;
  }

  .star-container2 {
    display: flex;
    font-size: 10px;
    color: #ccc;
    gap: 1px;
  }

  .star {
    position: relative;
    width: 1em;
  }

  .star-filled {
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    color: #01875f;
  }

  .QKrU5e {
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);
  }

  .install-btn:hover {
    background-color: #056449 !important;
  }

  .progress-bar {
    border-radius: 4px;
    height: 36px;
    background: white;
    color: white;
    font-size: 0.875rem;
    margin: 6px;
    overflow: hidden;
    border: 1px solid rgb(1, 135, 95);
  }

  .progress {
    height: 100%;
    background-color: rgb(1, 135, 95);
    /* 进度条的颜色 */
    transition: width 0.5s ease;
    /* 平滑过渡效果 */
  }
</style>
